import { validators } from "utils/validators";
export const validateBin = (binValues) => {
  const { REQUIRE } = validators;
  let isValid = true
  let errorMsg = ''
  if (REQUIRE(binValues)) {
    errorMsg = `Please Enter Valid Bin Values`;
    isValid = false
  }
  else {
    const bins = binValues
      .split(',')
      .map((bin) => bin.trim());

    const invalidBins = bins.filter(
      (bin) => !/^\d{6}$/.test(bin) && !/^\d{8}$/.test(bin)
    );

    if (invalidBins.length > 0) {
      errorMsg = 'Each BIN must be either 6 or 8 digits';
      isValid = false
    } else if (bins.length > 50) {
      errorMsg = 'Maximum of 50 BINs are allowed';
      isValid = false
    }
  }
  return {isValid, errorMsg}
}

